import React, { useState } from 'react';
import styled from 'styled-components';

export const Clickable = styled.div`
    cursor: pointer;
`

export const Collapsable = styled.div`
    max-height: ${({ state }) => state ? 500 : 0}px;
    overflow:  ${({ state }) => state ? 'auto' : 'hidden'};
    transition: all 0.35s;
`

const Display = styled.div`
    opacity:  ${({ state }) => state ? '1' : '0'};
    pointer-events:  ${({ state }) => state ? '' : 'none'};
    transition: all 0.35s;
`

const ToggleClick = ({ show = false, content, children, ...props }) => {
    const [state, setState] = useState(show);

    return (
        <div>
            <Clickable onClick={() => setState(!state)}>
                {content}
            </Clickable>
            <Collapsable state={state}>
                <Display state={state}>
                    {children}
                </Display>
            </Collapsable>
        </div>
    )
}

export default ToggleClick;
